var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.67 2.76687H12.2506C12.6699 2.76687 13.0719 2.93344 13.3683 3.22993C13.6648 3.52641 13.8313 3.92854 13.8313 4.34783V15.4146C13.8313 15.8338 13.6648 16.236 13.3683 16.5325C13.0719 16.8289 12.6699 16.9955 12.2506 16.9955H2.76659C2.34737 16.9955 1.94532 16.8289 1.64888 16.5325C1.35245 16.236 1.18591 15.8338 1.18591 15.4146V4.34783C1.18591 3.92854 1.35245 3.52641 1.64888 3.22993C1.94532 2.93344 2.34737 2.76687 2.76659 2.76687H4.34726M5.1376 1.18591H9.87963C10.3161 1.18591 10.67 1.53982 10.67 1.97639V3.55735C10.67 3.99392 10.3161 4.34783 9.87963 4.34783H5.1376C4.70111 4.34783 4.34726 3.99392 4.34726 3.55735V1.97639C4.34726 1.53982 4.70111 1.18591 5.1376 1.18591Z",
    stroke: "white",
    strokeWidth: 2.37174,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon1);
export default __webpack_public_path__ + "static/media/tagIcon1.94a87aeb90ecc51d238c8c701e436c9c.svg";
export { ForwardRef as ReactComponent };